module.exports = __webpack_public_path__ + "static/media/onda-violeta-2.308b1c26.png";